<i18n lang='yml' src='../i18n/Flash.yml'></i18n>
<template>
    <div class="" v-if="isVisible"> 
        <div :class="`alert ${message_type && message_type == 'notice' ? 'alert-notice' : 'alert-error'}`">
            <button class="close alert-hide" aria-hidden="true" data-dismiss="alert" type="button" @click="hideMessage">
              <font-awesome-icon size="xs" :icon="['fa', 'times']" />
              <label class="sr-only">
               {{$t('.dismiss')}}
              </label>
            </button>
            <span v-html="formatted_message"></span>
        </div>
    </div>
</template>
<script>

    export default {
        props: {
            message_type: String,
            message_text: Array,
        },

        data() {
            return {
                isVisible: false,
                formatted_message: "",
            }
        },

        watch: {  
            message_text(newVal){
                if (newVal && newVal.length > 0) {
                  this.isVisible = true;
                  this.format_error_message(newVal) 
                 }               
                 else {
                    this.hideMessage()
                }
            }
        },

        methods: {
          hideMessage(){
              this.isVisible = false;
          },
          format_error_message(message_text) {
            if (this.message_type == 'error') {
              if (message_text.find(message => message.includes('<ul>'))) {
                  this.formatted_message = message_text[0]
                }
              else {
                this.formatted_message = this.$i18n.t('error')
                this.formatted_message += `<ul> <li> ${message_text.join('</li><li>')} </li> </ul>`;
              }
            }
            else {
              this.formatted_message = message_text[0] 
            }
          }
        }
    }
</script>
